(function () {
    angular
        .module('maApp.view.partials')
        .factory('OperationDialogState', OperationDialogState)

    function OperationDialogState() {

        function OperationDialogData(messageTitle, message, showContinueAction, showCancelAction, continueActionText, cancelActionText, isInfo, isDanger, isSuccess) {
            this.messageTitle = messageTitle || '';
            this.message = message || '';

            if (typeof showContinueAction == 'boolean') this.showContinueAction = showContinueAction;
            else this.showContinueAction = false;

            if (typeof showCancelAction == 'boolean') this.showCancelAction = showCancelAction;
            else this.showCancelAction = false;

            this.continueActionText = continueActionText || '';
            this.cancelActionText = cancelActionText || '';

            if (typeof isInfo == 'boolean') this.isInfo = isInfo;
            else this.isInfo = true;

            if (typeof isDanger == 'boolean') this.isDanger = isDanger;
            else this.isDanger = true;

            if (typeof isSuccess == 'boolean') this.isSuccess = isSuccess;
            else this.isSuccess = true;
        }

        function OperationDialogState(stateData, states) {
            if (!states) throw 'Cannot create OperationDialogState without a state argument';
            if (!stateData) throw 'Cannot create OperationDialogState without a stateData argument';
            this.states = states;           //and object with keys mapped to function. each function should change the properties of the stateData object
            this.originalStateData = new OperationDialogData();
            this.originalStateData = angular.extend(this.originalStateData, stateData); //add the user's arguments to the dialog data object
            if (!('default' in this.states)) {
                this.states.default = function (_stateData) {
                    _stateData = angular.extend({}, this.originalStateData);
                    return _stateData;
                };
            }

            this.stateData = angular.extend({}, this.originalStateData);     //The properties should be used as the data argument of your ngDialog.open() or .openConfirm(). This allows the modal to changed text between states
        }

        OperationDialogState.prototype.setState = function (stateName) {
            if (stateName in this.states) {
                this.states[stateName](this.stateData);
            }
        };

        return OperationDialogState;
    }
})();